import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  Box,
  Drawer,
  IconButton,
  Tooltip,
} from "@mui/material";

const SideBar = () => {
  const [navbar, setNavbar] = useState(false);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    setNavbar(location.pathname.includes("menu"));
  }, [location.pathname]);

  const handleNavigation = (path) => {
    history.replace(path);
  };

  const handleClose = () => {
    setNavbar(false);
    history.goBack();
  }


  return (
    <Drawer
      anchor="left"
      open={navbar}
      onClose={handleClose}
      sx={{ width: 80, flexShrink: 0 }}
      
    >
      <Box
        sx={{
          width: 80,
          padding: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "100%",
        }}
      >
        <IconButton onClick={() => history.goBack()} sx={{ marginBottom: 2 }}>
          <span className="material-symbols-outlined">close</span>
        </IconButton>
        <Tooltip title="Search" placement="right">
              <IconButton
                onClick={() => handleNavigation(location.pathname.replace("menu", "search"))}
              >
                <span className="material-symbols-outlined">search</span>
              </IconButton>
            </Tooltip>
        {/* Live Channels */}
        <Tooltip title="Live Channels" placement="right">
          <IconButton
            onClick={() => !location.pathname.includes("live") && handleNavigation("/live/")}
          >
            <span className="material-symbols-outlined">live_tv</span>
          </IconButton>
        </Tooltip>
        <Tooltip title="Movies" placement="right">
          <IconButton
            onClick={() => !location.pathname.includes("movie") && handleNavigation("/movie/")}
          >
            <span className="material-symbols-outlined">movie</span>
          </IconButton>
        </Tooltip>
        <Tooltip title="TV Series" placement="right">
          <IconButton
            onClick={() => !location.pathname.includes("series") && handleNavigation("/series/")}
          >
            <span className="material-symbols-outlined">video_library</span>
          </IconButton>
        </Tooltip>

        {/* Movies */}
        {location.pathname.includes("movie") && (
          <>
            <Tooltip title="Search" placement="right">
              <IconButton
                onClick={() => handleNavigation(location.pathname.replace("menu", "search"))}
              >
                <span className="material-symbols-outlined">search</span>
              </IconButton>
            </Tooltip>
            <Tooltip title="Select category" placement="right">
              <IconButton onClick={() => handleNavigation("/movie/category/")}>
                <span className="material-symbols-outlined">category</span>
              </IconButton>
            </Tooltip>
          </>
        )}

        {/* TV Series */}
        {location.pathname.includes("series") && (
          <>
            <Tooltip title="Search" placement="right">
              <IconButton
                onClick={() => handleNavigation(location.pathname.replace("menu", "search"))}
              >
                <span className="material-symbols-outlined">search</span>
              </IconButton>
            </Tooltip>
            <Tooltip title="Select category" placement="right">
              <IconButton onClick={() => handleNavigation("/series/category/")}>
                <span className="material-symbols-outlined">category</span>
              </IconButton>
            </Tooltip>
          </>
        )}

        {/* Account Info */}
        <Tooltip title="Account Info" placement="right">
          <IconButton onClick={() => handleNavigation("/info/")}>
            <span className="material-symbols-outlined">account_circle</span>
          </IconButton>
        </Tooltip>
      </Box>
    </Drawer>
  );
};

export default SideBar;
